export default "assets/images/icons/livraison-052ba4f9.svg";